import React, { Component } from 'react';
import CountUp from 'react-countup';
import { createRegistrationStatus, dbQuery  } from "../../../../api"
import { User, Users } from 'react-feather';

import '../../../../index.scss';

class EventTemplateCube extends Component {
    constructor(props) {
        super(props);
        this.qType = this.props.qType ? this.props.qType : 'number'
        this.state = {
            loading: true,
            data: 0,
            tUser: this.props.tUser
        }
    }

    doQuery = () => {
        if (this.props.query) {       
            dbQuery(this.props.query).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    this.setState({ data: d2, loading: false});                    
                }
            });
        } else this.setState({ loading: false});                    

    };

    componentDidMount() {
        this.doQuery();
    }

    componentDidUpdate(prevProps) {
        if(prevProps.tUser !== this.props.tUser) {
            this.setState({tUser: this.props.tUser});
        }
    }

    capitalize(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
    
    render() {
        if (this.state.loading) { return null; }
        const {tUser} = this.state;
        const {tEvent} = this.props;
        var tUserEvent = tUser ? tUser.events.find(x=>x.eventId === tEvent._id) : null;
        var data = tEvent.competitorCount

        var icon = <User className="font-primary" />;
        if (tEvent.teamSize > 1) icon = <Users className="font-primary" />;

        const status = createRegistrationStatus(tUserEvent);
        var bg="bg-danger";
        if (status.startsWith( "Waiting")) bg="bg-warning";
        if (status === "Ready!") bg = "bg-primary"

        const smallText = <>
            {data >= tEvent.min && <>&nbsp;Registered.</>}
            &nbsp;&nbsp;&nbsp;{`Max Rooms: ${tEvent.maxRoomCount}   /   Judges: ${tEvent.requiredJudgeCount}`}
        </>
        const smallContent = <>{data >= tEvent.min && <CountUp className="counter" end={data} />}<small>{smallText}</small></>

        return (
            <div className="card o-hidden widget-cards">
                <div className={`${bg} card-body`}>
                    <div className="media static-top-widget row">
                        <div className="icons-widgets col-3">
                            <div className="align-self-center text-center">{icon}</div>                                                
                        </div>
                        <div className="media-body col-9">
                            <span className="m-0">
                                <h3 style={{marginBottom: "0px"}}>{tEvent.title}</h3>
                            </span>
                            <h3 style={{lineHeight: "1em", fontSize: "15px"}} className="mb-0">
                                {smallContent}
                            </h3>                           
                        </div>
                      
                    </div>
                </div>
            </div>    
        )
    }
}

export default EventTemplateCube;